import { DataGrid, GridColDef, GridActionsCellItem } from "@mui/x-data-grid";
import { Box, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useState } from "react";
import { ListItemDto } from "api/PricingPlatformApi.generated";

interface ListItemTableProps {
  dataList: ListItemDto[] | { id: number; name: string }[];
  columns?: GridColDef[];
  onEdit?: (item: ListItemDto) => void;
  onDelete?: (item: ListItemDto) => boolean;
}

const ListItemTable = (props: ListItemTableProps) => {
  const { dataList, onEdit, onDelete } = props;
  const [rows, setRows] = useState(dataList);

  const handleEditClick = (item: ListItemDto) => {
    if (onEdit) {
      onEdit(item);
    }
  };

  const handleDeleteClick = (item: ListItemDto) => {
    if (onDelete) {
      const didDelete = onDelete(item);
      if (didDelete) {
        //setRows(rows.filter((row) => row.value !== item.value));
      }
    }
  };

  const defaultColumns: GridColDef[] = [
    { field: "label", headerName: "Name", flex: 1.1 },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      type: "actions",
      renderCell: (params) => (
        <div>
          {onEdit && (
            <IconButton
              aria-label="edit"
              color="primary"
              onClick={() => handleEditClick(params.row)}
            >
              <EditIcon />
            </IconButton>
          )}
          {onDelete && (
            <IconButton
              aria-label="delete"
              color="error"
              onClick={() => handleDeleteClick(params.row)}
            >
              <DeleteIcon />
            </IconButton>
          )}
        </div>
      ),
    },
  ];

  return (
    <Box sx={{ width: "100%" }}>
      <DataGrid
        rows={rows}
        getRowId={(row) => row.value}
        columns={props.columns ?? defaultColumns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        autoHeight={true}
        pageSizeOptions={[5, 10, 20]}
        disableRowSelectionOnClick
      />
    </Box>
  );
};

export default ListItemTable;
